import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_03, PROMETHEAN_TYPOGRAPHY_BODY } from '../../styles/typography/typography';
import { EmbersMenuLaunchButton } from '../../menu/menuLaunchButton';
export var ORG_ROOT_PREFIX = 'EmbersHeader-OrgDropdown';
export var StyledOrgDropdown = styled(EmbersMenuLaunchButton)(function () {
  var _objectSpread2, _ref;
  return _ref = {}, _defineProperty(_ref, "&.".concat(ORG_ROOT_PREFIX, "-hasNotification"), {
    marginLeft: 24
  }), _defineProperty(_ref, "&.".concat(ORG_ROOT_PREFIX, "-hasNotification.").concat(ORG_ROOT_PREFIX, "-menuWithIcon.").concat(ORG_ROOT_PREFIX, "-noMenuNeeded"), {
    marginLeft: 0
  }), _defineProperty(_ref, "&.".concat(ORG_ROOT_PREFIX, "-menuWithIcon"), {
    '.icon-expand-more': {
      marginLeft: '0 !important'
    },
    '.icon-expand-less': {
      marginLeft: '0 !important'
    }
  }), _defineProperty(_ref, "&.".concat(ORG_ROOT_PREFIX, "-OrgName"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, (_objectSpread2 = {
    color: PROMETHEAN_NEUTRAL_WHITE,
    height: 24,
    userSelect: 'none',
    cursor: 'pointer'
  }, _defineProperty(_objectSpread2, "&.".concat(ORG_ROOT_PREFIX, "-noMenuNeeded"), {
    cursor: 'unset'
  }), _defineProperty(_objectSpread2, "display", 'flex'), _defineProperty(_objectSpread2, "alignItems", 'center'), _defineProperty(_objectSpread2, "justifyContent", 'flex-end'), _defineProperty(_objectSpread2, "maxWidth", 184), _defineProperty(_objectSpread2, "padding", 0), _defineProperty(_objectSpread2, '[class^="icon-"]', {
    fontSize: 16,
    marginLeft: 4
  }), _defineProperty(_objectSpread2, '.icon-organization', {
    fontSize: 24
  }), _defineProperty(_objectSpread2, ".".concat(ORG_ROOT_PREFIX, "-OrgName-content"), {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }), _defineProperty(_objectSpread2, "outline", 'none'), _defineProperty(_objectSpread2, '&:focus-visible', {
    outline: '2px solid ' + PROMETHEAN_NEUTRAL_WHITE
  }), _objectSpread2))), _defineProperty(_ref, "&.".concat(ORG_ROOT_PREFIX, "-multiOrgWide"), _defineProperty({}, "& .".concat(ORG_ROOT_PREFIX, "-OrgName"), _objectSpread(_objectSpread({
    backgroundColor: PROMETHEAN_NEUTRAL_WHITE
  }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
    '[class^="icon-"]': {
      fontSize: 24,
      marginRight: 3
    }
  }))), _ref;
});